import React, { useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import MonetOrganization from 'react/monet/fields/organization.jsx';
import { getResourceTo } from 'react/utils/utils';
import resources from './resources';
import filterTypes from './filterTypes';

function TicketHubFilters(props) {
  const { fetchTicketsAction, ticketHubIsOpen } = props;
  const defaultFilterRef = useRef(null);
  const checkBoxFilter = useRef(null);

  let organizationField;

  const setOrganizationFieldToVisible = () => organizationField.updateState(true);

  useEffect(() => {
    setOrganizationFieldToVisible();
  }, []);

  useEffect(() => {
    if (!ticketHubIsOpen) {
      organizationField.state.organization.clear();
      defaultFilterRef.current.value = '';
      checkBoxFilter.current.checked = '';
    }
  }, [ticketHubIsOpen]);

  const debouncedChangeHandler = useMemo(
    () => debounce((query, filterType) => fetchTicketsAction({ query, filterType }), 500), []
  );

  const changeHandlerDefaultFilter = (event) => {
    const query = event.target.value;
    debouncedChangeHandler(query, filterTypes.default);
  };

  const changeHandlerOrganizationFilter = (_, id) => {
    debouncedChangeHandler(id, filterTypes.organization);
  };

  const changeHandlerCheckboxFilter = (event) => {
    const query = event.target.checked;
    debouncedChangeHandler(query, filterTypes.assignedToMe);
  };

  return (
    <div className="ticketHub__filters">
      <div className="ticketHub__standardFilter">
        <input
          ref={defaultFilterRef}
          type="text"
          id="ticketHub__standardFilter-input"
          placeholder={getResourceTo(resources.defaultFilterLabel)}
          onChange={changeHandlerDefaultFilter}
        />
        <label htmlFor="ticketHub__standardFilter" title="search tickets" />
      </div>
      <MonetOrganization
        ref={(organizationFieldRendered) => { organizationField = organizationFieldRendered; }}
        afterSelectRow={changeHandlerOrganizationFilter}
        className="ticketHub__organizationFilter"
        entity="Live"
      />
      <div className="ticketHub__checkBoxFilter">
        <input
          ref={checkBoxFilter}
          type="checkbox"
          id="ticketHub__checkBoxFilter-input"
          onChange={changeHandlerCheckboxFilter}
        />
        <label htmlFor="ticketHub__checkBoxFilter-input">
          {getResourceTo(resources.checkBoxFilterLabel)}
        </label>
      </div>
    </div>
  );
}

TicketHubFilters.propTypes = {
  fetchTicketsAction: PropTypes.func.isRequired,
  ticketHubIsOpen: PropTypes.bool
};

TicketHubFilters.defaultProps = {
  ticketHubIsOpen: false
};

export default React.memo(TicketHubFilters);
